// utils/trackNotificationEvent.js
// Adjust path as needed

import { addEventParam, KissanEventType, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import { logEvent } from '@ninjacart/nc-nk-firebase';

export async function trackNotificationSentEvent({
  notificationTitle,
  campaignId,
  fcmMessageId,
  deeplinkingUrl,
  sourceReferenceId,
  sourceReferenceType,
  showTimer,
  startTime,
  endTime,
  deviceId
}: {
  notificationTitle: string;
  campaignId: string;
  fcmMessageId: string;
  deeplinkingUrl: string;
  sourceReferenceId?: string;
  sourceReferenceType?: string;
  showTimer?: string;
  startTime?: string;
  endTime?: string;
  deviceId?: string;
}) {
  const processEvents = useQueuedEventStore.getState()?.processEvents;
  const additionalDetails = [
    addEventParam('title', notificationTitle),
    addEventParam('campaignId', campaignId),
    addEventParam('fcmMessageId', fcmMessageId),
    addEventParam('deeplinkingUrl', deeplinkingUrl),
  ];

  if (sourceReferenceId) {
    additionalDetails.push(addEventParam('sourceReferenceId', sourceReferenceId));
  }
  if (sourceReferenceType) {
    additionalDetails.push(addEventParam('sourceReferenceType', sourceReferenceType));
  }

  logEvent('NOTIFICATION_SENT', {
    screen: 'notification page',
    deviceId: deviceId,
    campaignId: campaignId || '-1',
  });

  await processEvents?.([
    {
      name: KissanEventType.NOTIFICATION_SENT,
      screenDetails: { screen: 'notification page' },
      eventParams: additionalDetails,
    },
  ]);
}
